
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class ShippingReportDialog extends Serenity.EntityDialog<ShippingReportRow, any> {
        protected getFormKey() { return ShippingReportForm.formKey; }
        protected getIdProperty() { return ShippingReportRow.idProperty; }
        protected getLocalTextPrefix() { return ShippingReportRow.localTextPrefix; }
        protected getNameProperty() { return ShippingReportRow.nameProperty; }
        protected getService() { return ShippingReportService.baseUrl; }
        protected getDeletePermission() { return ShippingReportRow.deletePermission; }
        protected getInsertPermission() { return ShippingReportRow.insertPermission; }
        protected getUpdatePermission() { return ShippingReportRow.updatePermission; }

        protected form = new ShippingReportForm(this.idPrefix);

    }
}